import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import _ from 'lodash'

import { Body1 } from 'pharmacy/src/typography'
import { Checkbox } from 'pharmacy/src/input/checkbox'

import { makeRequestName } from 'mednet-cns/src/reducers/request'
import {
  toggleUserSubspecialty,
  TOGGLE_USER_SUBSPECIALTY,
  getToggleUserSubspecialtyRequestId,
} from 'mednet-cns/src/reducers/subspecialty'

import { StarLoader } from 'pharmacy/src/misc/loaders/starLoader'

import css from './toggleUserSubspecialtyButton.scss'

class ToggleUserSubspecialtyButton extends React.Component {
  handleToggle = () => {
    const { subspecialty, currentUserId, toggleUserSubspecialty } = this.props

    toggleUserSubspecialty(
      currentUserId,
      subspecialty.isAssignedToCurrentUser ? 'remove' : 'add'
    )
  }

  render() {
    const { subspecialty, isLoading, className } = this.props

    const containerClasses = classNames(css.container, className)
    const isChecked = subspecialty?.isAssignedToCurrentUser || false
    const labelClasses = classNames(css.subspecialtyLabel, {
      [css.checked]: isChecked,
    })

    return (
      <label className={containerClasses}>
        {isLoading ? (
          <div className={css.loaderContainer}>
            <StarLoader size="small" isVerticalMargin={false} />
          </div>
        ) : (
          <Checkbox
            checked={isChecked}
            onChange={this.handleToggle}
            disabled={isLoading}
          />
        )}
        <Body1 className={labelClasses}>{subspecialty?.subspecialty}</Body1>
      </label>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const subspecialties = state.subspecialty?.subspecialties ?? {}
  const subspecialty = subspecialties[ownProps.subspecialtyId]
  const currentUserId = state.user.data?.userId
  const toggleRequest =
    _.get(
      state.request.requests,
      makeRequestName(
        TOGGLE_USER_SUBSPECIALTY,
        getToggleUserSubspecialtyRequestId(
          subspecialty?.subspecialtyId,
          currentUserId
        )
      )
    ) || {}

  return {
    subspecialty,
    currentUserId,
    isLoading: toggleRequest.isLoading,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    toggleUserSubspecialty: (userId, action) =>
      dispatch(toggleUserSubspecialty(ownProps.subspecialtyId, userId, action)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToggleUserSubspecialtyButton)
